import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Importing icons
import MicIcon from '@mui/icons-material/MicRounded';
import MusicIcon from '@mui/icons-material/MusicNoteRounded';
import NextIcon from '@mui/icons-material/ArrowForwardIosRounded';
// Importing types
import { MediaChapterType } from '../../../types/media';
// Importing 3rd party components
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// ----------------------------------------------------------------------
export const CurrentChapterIndicator = (props) => {
    // Destructuring props
    const { chapter, clickable = false, containerStyle = {}, fontStyle = { color: 'white', fontSize: 12 }, iconStyle = { color: 'white', fontSize: 14 }, separator = false, } = props;
    // Resolving type issues from chapter type input
    const chapterType = chapter
        ? MediaChapterType[chapter.type]
        : undefined;
    return (_jsxs(_Fragment, { children: [separator && (_jsx(Typography, { color: "white", variant: "caption", children: "\u2022" })), !clickable && (_jsx(DefaultChapterIndicator, { chapter: chapter, chapterType: chapterType, containerStyle: containerStyle, fontStyle: fontStyle, iconStyle: iconStyle })), clickable && (_jsx(LinkedChapterIndicator, { chapter: chapter, chapterType: chapterType, containerStyle: containerStyle, fontStyle: fontStyle, iconStyle: iconStyle }))] }));
};
// ----------------------------------------------------------------------
const DefaultChapterIndicator = (props) => {
    // Destructuring props
    const { chapter, chapterType, containerStyle, fontStyle, iconStyle } = props;
    return (_jsxs(Stack, { direction: "row", spacing: 1, sx: Object.assign({ alignItems: 'center' }, containerStyle), children: [chapterType === MediaChapterType.music && _jsx(MusicIcon, { sx: iconStyle }), chapterType === MediaChapterType.spokenword && _jsx(MicIcon, { sx: iconStyle }), _jsx(Typography, { noWrap: true, sx: fontStyle, children: chapter.title })] }));
};
// ----------------------------------------------------------------------
export const LinkedChapterIndicator = (props) => {
    // Destructuring props
    const { iconStyle } = props;
    return (_jsxs(Link, { sx: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'row',
            textDecoration: 'none',
        }, children: [_jsx(DefaultChapterIndicator, Object.assign({}, props)), _jsx(NextIcon, { sx: Object.assign(Object.assign({}, iconStyle), { ml: 1 }) })] }));
};
